<div *ngIf="serviceOutageMessage"
     class="emergency-message">
    {{serviceOutageMessage}}
</div>

<img src="assets/stacked-blu.svg"
     class="login-logo"/>

<router-outlet></router-outlet>

<p class="privacy-policy">
    By signing into this site, you agree and acknowledge the <a target="_blank"
                                                                href="https://www.spscommerce.com/about/privacy-policy/">Privacy
    Policy</a>
</p>
